/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Player, { type VideoProps } from 'components/Video/Video';
import useAnimation from './animations';
import './Video.scss';

const DEFAULT_VIDEO: VideoProps = {};

interface HeaderVideoProps {
  video?: VideoProps;
  title?: string;
}

/**
 * This is the Video component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Video({ video = DEFAULT_VIDEO, title }: HeaderVideoProps) {
  const [ref] = useAnimation();

  return (
    <header ref={ref} className="header header-video">
      <Player {...video} />
      <h1>{title}</h1>
    </header>
  );
}

export default Video;
